import styled from "styled-components";

import { PageWrapperBase } from "Components/Website.style";

//IMAGES
import { Dialog } from "@material-ui/core";
//CONST
import { FONTS, responsive, COLORS } from "Styles/Constants";
import { IMAGES } from "Helpers";

export const PageWrapper = styled(PageWrapperBase)`
	color: #fff;
	position: relative;
	margin-left: -2px;

	.background-image {
		position: absolute;
		height: 100%;
		width: 100%;
		z-index: -1;
		overflow: hidden;
	}

	.content {
		width: 70%;
		/* ${responsive.DESKTOP`width: 63%;`} */

		.overlay-stackrank {
			position: relative;
			.overlay-effect {
				opacity: 0.7;
			}
			.display-circular-progress {
				position: absolute;
				left: 50%;
				bottom: 50%;
			}
			.MuiCircularProgress-colorPrimary {
				color: #000;
			}
		}

		.title {
			width: 70%;
			margin: 0 auto;
			margin-top: -12%;

			@media screen and (min-width: 1750px) {
				margin-top: -14%;
			}
			@media screen and (min-width: 1920px) {
				margin-top: -16%;
			}

			@media screen and (min-width: 2560px) {
				margin-top: -23%;
			}
			${responsive.DESKTOP`width: 60%;
                margin-top:22%;
            `}

			@media screen and (max-width: 1440px) {
				margin-top: -7%;
			}
			${responsive.LAPTOP`width: 80%;
                margin-top:22%;
            `}

			${responsive.TABLET`margin-top:33%;`}
        .text {
				font-family: ${FONTS.PRIMARY_LIGHT};
				font-size: 29px;
				margin-bottom: 40px;

				@media screen and (min-width: 1750px) {
					font-size: 34px;
				}
				@media screen and (min-width: 1920px) {
					font-size: 37px;
				}

				@media screen and (min-width: 2560px) {
					font-size: 49px;
				}

				${responsive.DESKTOP`font-size: 21px;`}

				${responsive.TABLET`
                    font-size: 18px;
                    top:14%
                `}
			}
		}

		.game-card {
			/* margin-top: 8%; */

			/* @media screen and (min-width: 1920px) {
                margin-top: 5%;
            } */
		}
	}
`;

export const GridContainer = styled.div`
	flex-wrap: wrap;

	.box {
		width: 25%;
		${responsive.LAPTOP`width:33.33%`}
		${responsive.TABLET`width:35%`}

		.disabled {
			pointer-events: none;
			filter: grayscale(80%);
			cursor: not-allowed;
		}

		.box-content {
			cursor: pointer;
			margin: 0 auto;
			width: 270px;
			height: 270px;
			position: relative;
			transition: 0.3s;
			width: 90%;
			position: relative;
			&:hover {
				transform: scale(1.05);
			}

			${responsive.DISPLAY`height: 255px; width: 255px;`}

			${responsive.DISPLAY_1550` width: 100%; padding: 2px`}

			.img-container {
				width: 100%;
				height: 100%;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				position: relative;
				margin: 0 auto;
			}

			.title {
				font-size: 24px;
				padding-top: 17px;

				${responsive.DISPLAY`
                    font-size: 22px;
                    padding-top: 12px;
                `}

				${responsive.LAPTOP`
                    font-size: 18px;
                    padding-top: 12px;
                `}
			}

			.progress-container {
				bottom: 15px;
				padding: 0 15%;
				position: absolute;

				/* ${responsive.DISPLAY` bottom : 16px;`} */
			}
		}
	}
`;

export const ProgressWrapper = styled.div`
	text-align: left;

	.outer {
		background-color: #001d46;
		border: 1px solid rgba(59, 219, 255, 0.3);
		border-radius: 50px;
		width: 70%;
		margin: 0px auto;
		${responsive.DISPLAY`width: 80%; `}
		${responsive.LAPTOP` width: 80%;`}
        .active {
			border-radius: 50px;
			height: 7px;
			background: #da2323;
			width: ${(props) => props.value}%;
			transition: 0.5s ease;

			${responsive.DISPLAY`height: 6px;`}
		}
	}

	.text {
		width: 70%;
		margin: 0px auto;
		color: #000;
		${responsive.DISPLAY`width: 80%;`}
		text-align: center;
		padding-top: 5px;
	}
`;

export const ScoreboardWrapper = styled.div`
	position: absolute;
	right: 2px;
	top: 150px;
	width: 300px;
	height: 680px;
	background-repeat: no-repeat;
	background-size: cover;
	background-image: url(${IMAGES.FOREIGN.LEADERBOARD});

	${responsive.DISPLAY` width : 235px; height:536px`}
	${responsive.LAPTOP` width : 190px; height:440px`}


    .scoreboard-title {
		font-size: 20px;
		text-align: center;
		padding-top: 5px;
		${responsive.DISPLAY`font-size: 18px; `}
	}
	.title {
		text-align: center;
		position: relative;
		z-index: 4;
		color: #fff;

		.image {
			width: 85%;
		}
		.text-container {
			margin-top: -39px;
			${responsive.DISPLAY`margin-top: -34px;`}

			.text {
				font-size: 18px;
				${responsive.DISPLAY`font-size: 14px; `}
			}
		}
	}

	.people-cards {
		margin-top: 56px;
		margin-left: 10px;
		/* ${responsive.LAPTOP`margin-top: 56px;`} */
		.person {
			width: 100%;
			height: 200px;

			&:nth-child(1) {
				z-index: 3;
				${responsive.LAPTOP`margin-top: 5px;`}
			}
			&:nth-child(2) {
				z-index: 2;
				${responsive.LAPTOP`margin-top: 5px;`}
			}
			&:nth-child(3) {
				z-index: 1;
				${responsive.LAPTOP`margin-top: 5px;`}
			}

			${responsive.DISPLAY`height : 155px;`}
			${responsive.LAPTOP`height : 115px;`}
            .content {
				.image {
					border: 3px solid ${COLORS.SECONDARY};
					border-radius: 10px;
					margin: 0 auto;

					background-repeat: no-repeat;
					background-size: cover;
					background-position: center;

					height: 75px;
					width: 75px;

					${responsive.DISPLAY`height: 60px; width: 60px;`}
					${responsive.LAPTOP`height: 50px; width: 50px;`}
				}
				.name {
					font-size: 20px;
					margin-top: 5px;
					color: black;
					${responsive.DISPLAY`font-size: 18px;`}
				}

				.score {
					background-color: #0c0d47;
					border-radius: 5px;
					display: inline-block;
					padding: 2px 12px;
					color: #fff;
				}
			}
		}
	}
`;

export const DialogWrapper = styled(Dialog)`
	.MuiBackdrop-root {
		background-color: rgba(0, 0, 0, 0.8);
	}

	.MuiDialog-paper {
		background: transparent;
		color: #fff;
		overflow: visible;
	}

	.box {
		min-width: 650px;

		.title-container {
			position: relative;
			.title {
				margin-bottom: 10px;
			}

			.sub-title {
				font-size: 22px;
				margin-top: 10px;
			}

			.icon-container {
				cursor: pointer;
				position: absolute;
				right: 23px;
				top: -4px;

				.icon {
					color: ${COLORS.SECONDARY};
					font-size: 35px;
				}
			}
		}

		.content-wrapper {
			padding: 10px 10px 35px;
			position: relative;

			.content {
				padding-right: 10px;
			}
		}
	}
	.button-wrapper {
		margin-top: -25px;
		text-align: center;

		.styled {
			min-width: 185px;
		}
	}
`;
